import {
  list,
  add,
  show,
  updatedep,
  deleteDepartment,
  departmentDetails,
  getDaySlots,
  getCompanyDetails,
  departmentDetailsBySlug
} from '@/api/department'

import {
  getAppointmentByUuid
} from '@/api/appointment'

import Cookies from 'js-cookie'

const department = {
  state: {
    header: (Cookies.get('header')) ? Cookies.get('header') : {},
    company_name: (Cookies.get('company_name')) ? Cookies.get('company_name') : {},
    company_img: (Cookies.get('company_img')) ? Cookies.get('company_img') : {},
    header_footer: (Cookies.get('header_footer')) ? Cookies.get('header_footer') : {},
    available_staff_ids: {},
    onlineChannels: new Map()
  },
  mutations: {
    HEADER: (state, header) => {
      state.header = header
    },
    HEADER_FOOTER: (state, header_footer) => {
      state.header_footer = header_footer
    },
    COMPANY_NAME: (state, name) => {
      state.company_name = name
    },
    COMPANY_IMG: (state, img) => {
      state.company_img = img
    },
    SET_DEPARTMENT_ONLINE_CHANNEL: (state, {id, channel}) => {
      state.onlineChannels.set(id, channel);
    },
    SET_DEPARTMENT_AVAILABLE_STAFF_IDS: (state, {id, staffIds = []}) => {
      const oldState = {...state.available_staff_ids};
      oldState[id] = staffIds;
      state.available_staff_ids = oldState;
    },
    UNSET_DEPARTMENT_AVAILABLE_STAFF_ID: (state, {id, staffId}) => {
      const oldState = {...state.available_staff_ids};
      oldState[id] = (oldState[id] || []).filter(staff_id => staff_id != staffId);
      state.available_staff_ids = oldState;
    }  
  },
  actions: {
    /**
     * Get all compainies list
     * @param {*} param0 
     * @author Madhura Shah
     */
    Departments({
      commit
    }, id) {

      return new Promise((resolve, reject) => {
        list(id).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    /**
     *
     *  Add Department    method  for Add department of list    **/

    AddDepartment({
      commit
    }, departments) {


      return new Promise((resolve, reject) => {
        add(departments).then(response => {

          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    /**
     *
     *  how Department    method  for specific department of list    **/

    ShowDepartment({
      commit
    }, id) {

      return new Promise((resolve, reject) => {
        show(id).then(response => {

          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    /**
     *
     * Update Department    method  for update specific department of list    **/

    UpdateDepartment({commit}, departments) {
      return new Promise((resolve, reject) => {
        updatedep(departments).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     *
     *  Delete Department    method  for delete specific department of list    **/

    Deletedep({
      commit
    }, departments) {
      return new Promise((resolve, reject) => {
        deleteDepartment(departments).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * department details
     * @param {*} param0 
     * @param {*} departments 
     */
    DepartmentDetails({
      commit
    }, id) {
      return new Promise((resolve, reject) => {
        departmentDetails(id).then(response => {
          if(response.data.data) {
            if(response.data.data.profile_image)
             commit('COMPANY_IMG', response.data.data.profile_image);
            commit('COMPANY_NAME', response.data.data.company_name)
            commit('HEADER',response.data.data.enable_header_footer);
            commit('HEADER_FOOTER',response.data.data.enable_header_footer_for_embedded);
          }
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    /**
    * department details
    * @param {*} param0 
    * @param {*} departments 
    */
   DepartmentDetailsBySlug({commit}, slug) {
    return new Promise((resolve, reject) => {
      departmentDetailsBySlug(slug).then(response => {
        if(response.data.data) {
          commit('COMPANY_NAME', response.data.data.company_name)
          commit('HEADER',response.data.data.enable_header_footer);
          commit('HEADER_FOOTER',response.data.data.enable_header_footer_for_embedded);
        }
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

    /**
     * department details
     * @param {*} param0 
     * @param {*} departments 
     */
    GetDaySlots({commit}, data) {
      return new Promise((resolve, reject) => {
        getDaySlots(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    /**
     * 
     * @param {*} param0 
     * @param {*} data 
     */
    CompanyDetails({commit}, data) {
      return new Promise((resolve, reject) => {
        getCompanyDetails(data).then(response => {
          if(response.data.data) {
            commit('COMPANY_IMG', response.data.data.profile_image);
            commit('COMPANY_NAME', response.data.data.company_name)
            commit('HEADER',response.data.data.enable_header_footer);
            commit('HEADER_FOOTER',response.data.data.enable_header_footer_for_embedded);
          }
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    /**
     * Get Appointment By Uuid
     * @param {*} param0 
     * @param {*} uuid 
     */
    GetAppointmentByUuid({commit}, uuid) {
      return new Promise((resolve, reject) => {
        getAppointmentByUuid(uuid).then(response => {
          if(response.data.data) {
            commit('COMPANY_IMG', response.data.data.profile_image);
            commit('COMPANY_NAME', response.data.data.company_name)
            commit('HEADER',response.data.data.enable_header_footer);
            commit('HEADER_FOOTER',response.data.data.enable_header_footer_for_embedded);
          }
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    /**
     * Set Header
     * @param {*} param0 
     * @param {*} departments 
     */
    SetHeader({commit}) {   
        commit('HEADER',false);      
    },

    initDepartmentStaffOnline({commit, state}, id) {
      const onlineDepartment = `department-online-${id}`;
      if(state.onlineChannels.has(id)) return;
      const channel = window.Echo.join(onlineDepartment)
      .here(staffIds => {
        console.log(onlineDepartment, {})
        commit('SET_DEPARTMENT_AVAILABLE_STAFF_IDS', {id, staffIds: staffIds.filter(id => typeof id == 'number')});
      })
      .joining(staffId => {
        if(typeof staffId == 'number') {
          const staffIds = state.available_staff_ids[id] || [];
          staffIds.push(staffId);
          commit('SET_DEPARTMENT_AVAILABLE_STAFF_IDS', {id, staffIds});
        }
      })
      .leaving(staffId => {
        if(typeof staffId == 'number') 
          commit('UNSET_DEPARTMENT_AVAILABLE_STAFF_ID', {id, staffId});
      });

      
      commit('SET_DEPARTMENT_ONLINE_CHANNEL', {id, channel});
    }
  },
}

export default department
